import { render, staticRenderFns } from "./zhihuijiaotong.vue?vue&type=template&id=bf52fdb2&scoped=true&"
import script from "./zhihuijiaotong.vue?vue&type=script&lang=js&"
export * from "./zhihuijiaotong.vue?vue&type=script&lang=js&"
import style0 from "./zhihuijiaotong.vue?vue&type=style&index=0&id=bf52fdb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf52fdb2",
  null
  
)

export default component.exports